import * as rudderClient from 'rudder-sdk-js'

rudderClient.load(
  `${process.env.EXPO_PUBLIC_RUDDERSTACK_TOKEN}`,
  `${process.env.EXPO_PUBLIC_RUDDERSTACK_DATA_PLANE_URL}`,
)

export { rudderClient }
